<template>
	<div>
    <b-breadcrumb
		v-if="breadcrumbList"
		:items="crumbs"
	></b-breadcrumb>
	</div>
</template>

<script>
export default {
	name: "Breadcrumb",
	data() {
		return {
			breadcrumbList: [],
		};
	},

	computed: {
		crumbs: function () {
			let pathArray = this.$route.path.split("/");
			let breadcrumb = this.breadcrumbList;

			if (pathArray.length == breadcrumb.length) {

				pathArray.forEach((path, i) => {
                 
					if (breadcrumb[i]) {
						breadcrumb[i].text = breadcrumb[i].text
							? breadcrumb[i].text
							: path;
					}
				});
			}
			return breadcrumb;
		},
	},

	mounted() {
		this.updateList();
	},
	watch: {
		$route() {
            this.updateList();
		},
	},
	methods: {
		updateList() {        
            this.breadcrumbList = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/layout/breadcrumb.vue